import { DiscountType } from "@trnsact/trnsact-shared-types";
import { logError } from "utils/logger";
import { formatStringToNumber } from "utils/formatters";
import { Equipment, EquipmentFormValue } from "../types";
import { calcAttachmentTotals, calcDiscount } from "./charges";

export function mapEquipmentEntityToFormValue(equipment: Equipment): EquipmentFormValue {
  try {
    const mappedEquipment: EquipmentFormValue["commonInfo"] = {
      year: equipment.year,
      make: equipment.make,
      model: equipment.model,
      class: equipment.classType,
      stockId: equipment.stockId,
      mileage: equipment.mileage,
      quality: equipment.quantity,
      condition: equipment.newUsed,
      vin: equipment.serialNumberVin,
      saleCost: equipment?.wholesaleCost ?? 0,
      retailPrice: equipment?.retailPrice ?? 0,
      wholeSaleCost: equipment?.wholesaleCost ?? 0,
      description: equipment.additionalDescription,
      discountValue: (equipment as any)?.discountValue,
      discountType: (equipment as any)?.discountType ?? DiscountType.Flat,
    };

    const mappedAttachments: EquipmentFormValue["attachments"] = (equipment?.attachments ?? []).map(attachment => ({
      ...attachment,
      retailPrice: attachment?.retailPrice ?? 0,
      discountValue: attachment?.discountValue ?? 0,
      unitCost: formatStringToNumber(attachment.unitCost) ?? 0,
      discountType: attachment?.discountType ?? DiscountType.Flat,
    }));

    const attachmentPrices = calcAttachmentTotals(mappedAttachments);

    return {
      commonInfo: mappedEquipment,
      attachments: mappedAttachments,
      calcPricing: {
        retail: {
          attachments: attachmentPrices.retailPrice,
          total: mappedEquipment.retailPrice + attachmentPrices.retailPrice,
        },
        wholesale: {
          attachments: attachmentPrices.wholesaleCost,
          total: mappedEquipment.saleCost + attachmentPrices.wholesaleCost,
        },
        customer: {
          attachments: attachmentPrices.customerPriceWithDiscount,
          equipment: calcDiscount(
            mappedEquipment.retailPrice,
            mappedEquipment.discountValue,
            mappedEquipment.discountType
          ),
          total:
            calcDiscount(mappedEquipment.retailPrice, mappedEquipment.discountValue, mappedEquipment.discountType) +
            attachmentPrices.customerPriceWithDiscount,
        },
      },
    };
  } catch (error) {
    logError(error);
    throw error;
  }
}
